module.exports = __webpack_public_path__ + "static/img/webchat.297ff4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/webchat.png
// module id = 1884
// module chunks = 0